import { Skeleton as MUISkeleton, Stack } from '@mui/material';

export const Skeleton = () => (
  <Stack spacing={2}>
    {[...Array(3)].map((_, index) => (
      <MUISkeleton key={index} variant="rounded" height={100} />
    ))}
  </Stack>
);
